export default {
    'usermenu.dialog.title': '信息',
    'usermenu.dialog.content': '您确定要注销吗？',
}
